import { render, staticRenderFns } from "./TranscriptImport.vue?vue&type=template&id=60e6ab0e&scoped=true&"
import script from "./TranscriptImport.vue?vue&type=script&lang=js&"
export * from "./TranscriptImport.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptImport.vue?vue&type=style&index=0&id=60e6ab0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e6ab0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VFileInput,VSpacer})
